import './SeriesPanel.css'

import { seriesList } from "../../index.js"
import BookImage from "../pages/page-content/books/book-layout/BookImage.jsx";
import { useState } from 'react';
import ActiveBook from './ActiveBook.jsx';
import Blurb from '../pages/page-content/books/book-layout/Blurb.jsx';

export default function SeriesPanel() {
	const series = seriesList[0]
	const defaultActiveBook = series.seriesBooks[series.seriesBooks.length-1]
	const [activeBook, setActiveBook] = useState(defaultActiveBook)
	
	// console.log(series);
	// console.log(activeBook)

	const handleSetActiveBook = (book) => {
		console.log(book)
		setActiveBook(book)
	}

	const scrollIntoView = (id) => {

		const element = document.getElementById(id);
		if (element) {
			element.scrollIntoView({
				behavior: "smooth",
				block: "start"
			});
		}
	}
	
	const bookImages = series.seriesBooks.map((book) => {
		
		return (
				<li key={book.id} className="series-book" onClick={() => {
					handleSetActiveBook(book);
					scrollIntoView("series");
				}}>
					<BookImage book={book} showLink={false}  /> 
				</li>
		)
	})

	
	
	return (
		<section id="series" className="series">
			<div className="series-title">
				<span>The Latest From </span>
				<span className="series-title-title">{series.seriesName} Series</span>
			</div>
			<ActiveBook book={activeBook} />
		
			<div className="other-books">
				<h4>Other Books in {series.seriesName} Series</h4>
				<ul className="series-books">
					{bookImages}
				</ul>
			</div>
				
			<div className="series-text">
				<div className="series-desc">
					<Blurb blurbNoVanish blurb={series.seriesDesc} /> 
				</div>
			</div>
			
		</section>
	)
}
